import React from "react";

import Background from "../../../assets/lunch/lunch-bg-02.png";
import Image from "../../../assets/lunch/lunch-choice-a.png";

import GamePageLayout from "../GamePageLayout";

const LunchPage4 = ({ setCurrentPage }) => {
  return (
    <GamePageLayout
      bg={Background}
      img={Image}
      onClickNext={() => setCurrentPage("dinner-1")}
    >
      그래.
      <br />
      팀원들 짜장면 먹는 건 먹는 거고
      <br />
      나는 내가 싸온 도시락을
      <br />
      옆에서 같이 먹자.
    </GamePageLayout>
  );
};

export default LunchPage4;
